// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 3840px) {
    .top-content-container{
        display: flex;
        box-sizing: border-box;
        padding: 0px 0px;
        margin-left: 15vw;
        margin-top: 5vh;
    }

    .top-content-text{
        margin-left: 15vw;
        margin-top: 5vh;
    }

    .top-content{
        height: 100%;
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 50px;
        cursor: pointer;
    }

    .top-content img{
        height: 60px;
    }

    .top-content p{
        margin-bottom: 0px;
    }

    .middle-content-container{
        display: flex;
        margin-top: 5vh;
        box-sizing: border-box;
        padding: 0px 0px;
        margin-left: 15vw;
    }

    .middle-content{
        height: 100%;
        display:flex;
        flex-direction: column;
        margin-right: 20px;
        cursor: pointer;
        border-radius: 10px;
        transition: 0.3s ease-out;
    }

    .middle-content:hover {
        color: #022452;
        box-shadow: 0 0 5px #022452;
        text-shadow: 0 0 5px #022452;
    }

    .middle-content img{
        width: 33vw;
        border-radius: 10px;
    }

    .bottom-content-title{
        margin-top: 5vh;
        margin-left: 15vw;
    }

    .bottom-content-container{
        display: flex;
        box-sizing: border-box;
        padding: 0px 0px;
        margin-left: 15vw;
    }

    .bottom-content{
        height: 100%;
        display:flex;
        flex-direction: column;
        margin-right: 20px;
        cursor: pointer;
        transition: 0.3s ease-out;
    }

    .bottom-content:hover {
        color: #022452;
        box-shadow: 0 0 5px #022452;
        text-shadow: 0 0 5px #022452;
    }

    .bottom-content img{
        width: 33vw;
        border-radius: 10px;
    }

    .page-content-title{
        margin-top: 20px;
        margin-left: 20px;
        font-size: 40px;
    }

    .page-title{
        margin-top: 5vh;
    }

    .page-title-description{
        margin-top: 1vh;
    }

    .book-image{
        width: 50%;
        border-radius: 10px;
        margin-top: 20px;
        max-width: 400px;
    }

    .facebook-image{
        width: 100%;
        border-radius: 10px;
        margin-top: 20px;
        max-width: 400px;
    }
}

@media screen and (max-width: 540px) {
    .top-content-container{
        display: flex;
        margin-top: 30px;
        box-sizing: border-box;
        padding: 0px 0px;
        margin-left: 0;
    }

    .top-content-text{
        display: none;
    }

    .top-content{
        height: 100%;
        display:flex;
        flex-direction: column;
        margin-left: 20px;
        justify-content: center;
        align-items: center;
        margin-right: 0px;
    }

    .top-content img{
        height: 60px;
    }

    .top-content p{
        margin-bottom: 0px;
    }

    .middle-content-container{
        display: flex;
        margin-top: 20px;
        box-sizing: border-box;
        padding: 0px 0px;
        margin-left: 0;
    }

    .middle-content{
        height: 100%;
        display:flex;
        flex-direction: column;
        margin-left: 20px;
        
    }

    .middle-content img{
        width: 40vw;
        border-radius: 10px;
    }

    .bottom-content-title{
        margin-top: 20px;
        margin-left: 20px;
    }

    .bottom-content-container{
        display: flex;
        box-sizing: border-box;
        padding: 0px 0px;
        margin-left: 0;
    }

    .bottom-content{
        height: 100%;
        display:flex;
        flex-direction: column;
        margin-left: 20px;
    }

    .bottom-content img{
        width: 40vw;
        border-radius: 10px;
    }

    .page-content-title{
        margin-top: 20px;
        margin-left: 20px;
        font-size: 24px;
    }

    .page-title{
        margin-top: 20px;
        margin-left: 20px;
    }

    .page-title-description{
        margin-top: 20px;
        margin-left: 20px;
    }

    .book-image{
        width: 80%;
        border-radius: 10px;
        margin-top: 20px;
    }

    .facebook-image{
        width: 60%;
        border-radius: 10px;
        margin-top: 20px;
    }

}`, "",{"version":3,"sources":["webpack://./src/pages/Main.css"],"names":[],"mappings":"AAAA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,sBAAsB;QACtB,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,sBAAsB;QACtB,kBAAkB;QAClB,eAAe;QACf,mBAAmB;QACnB,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,2BAA2B;QAC3B,4BAA4B;IAChC;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,sBAAsB;QACtB,kBAAkB;QAClB,eAAe;QACf,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,2BAA2B;QAC3B,4BAA4B;IAChC;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,gBAAgB;QAChB,sBAAsB;QACtB,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,sBAAsB;QACtB,iBAAiB;QACjB,uBAAuB;QACvB,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,sBAAsB;QACtB,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,sBAAsB;QACtB,iBAAiB;;IAErB;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,mBAAmB;QACnB,gBAAgB;IACpB;;AAEJ","sourcesContent":["@media screen and (max-width: 3840px) {\n    .top-content-container{\n        display: flex;\n        box-sizing: border-box;\n        padding: 0px 0px;\n        margin-left: 15vw;\n        margin-top: 5vh;\n    }\n\n    .top-content-text{\n        margin-left: 15vw;\n        margin-top: 5vh;\n    }\n\n    .top-content{\n        height: 100%;\n        display:flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        margin-right: 50px;\n        cursor: pointer;\n    }\n\n    .top-content img{\n        height: 60px;\n    }\n\n    .top-content p{\n        margin-bottom: 0px;\n    }\n\n    .middle-content-container{\n        display: flex;\n        margin-top: 5vh;\n        box-sizing: border-box;\n        padding: 0px 0px;\n        margin-left: 15vw;\n    }\n\n    .middle-content{\n        height: 100%;\n        display:flex;\n        flex-direction: column;\n        margin-right: 20px;\n        cursor: pointer;\n        border-radius: 10px;\n        transition: 0.3s ease-out;\n    }\n\n    .middle-content:hover {\n        color: #022452;\n        box-shadow: 0 0 5px #022452;\n        text-shadow: 0 0 5px #022452;\n    }\n\n    .middle-content img{\n        width: 33vw;\n        border-radius: 10px;\n    }\n\n    .bottom-content-title{\n        margin-top: 5vh;\n        margin-left: 15vw;\n    }\n\n    .bottom-content-container{\n        display: flex;\n        box-sizing: border-box;\n        padding: 0px 0px;\n        margin-left: 15vw;\n    }\n\n    .bottom-content{\n        height: 100%;\n        display:flex;\n        flex-direction: column;\n        margin-right: 20px;\n        cursor: pointer;\n        transition: 0.3s ease-out;\n    }\n\n    .bottom-content:hover {\n        color: #022452;\n        box-shadow: 0 0 5px #022452;\n        text-shadow: 0 0 5px #022452;\n    }\n\n    .bottom-content img{\n        width: 33vw;\n        border-radius: 10px;\n    }\n\n    .page-content-title{\n        margin-top: 20px;\n        margin-left: 20px;\n        font-size: 40px;\n    }\n\n    .page-title{\n        margin-top: 5vh;\n    }\n\n    .page-title-description{\n        margin-top: 1vh;\n    }\n\n    .book-image{\n        width: 50%;\n        border-radius: 10px;\n        margin-top: 20px;\n        max-width: 400px;\n    }\n\n    .facebook-image{\n        width: 100%;\n        border-radius: 10px;\n        margin-top: 20px;\n        max-width: 400px;\n    }\n}\n\n@media screen and (max-width: 540px) {\n    .top-content-container{\n        display: flex;\n        margin-top: 30px;\n        box-sizing: border-box;\n        padding: 0px 0px;\n        margin-left: 0;\n    }\n\n    .top-content-text{\n        display: none;\n    }\n\n    .top-content{\n        height: 100%;\n        display:flex;\n        flex-direction: column;\n        margin-left: 20px;\n        justify-content: center;\n        align-items: center;\n        margin-right: 0px;\n    }\n\n    .top-content img{\n        height: 60px;\n    }\n\n    .top-content p{\n        margin-bottom: 0px;\n    }\n\n    .middle-content-container{\n        display: flex;\n        margin-top: 20px;\n        box-sizing: border-box;\n        padding: 0px 0px;\n        margin-left: 0;\n    }\n\n    .middle-content{\n        height: 100%;\n        display:flex;\n        flex-direction: column;\n        margin-left: 20px;\n        \n    }\n\n    .middle-content img{\n        width: 40vw;\n        border-radius: 10px;\n    }\n\n    .bottom-content-title{\n        margin-top: 20px;\n        margin-left: 20px;\n    }\n\n    .bottom-content-container{\n        display: flex;\n        box-sizing: border-box;\n        padding: 0px 0px;\n        margin-left: 0;\n    }\n\n    .bottom-content{\n        height: 100%;\n        display:flex;\n        flex-direction: column;\n        margin-left: 20px;\n    }\n\n    .bottom-content img{\n        width: 40vw;\n        border-radius: 10px;\n    }\n\n    .page-content-title{\n        margin-top: 20px;\n        margin-left: 20px;\n        font-size: 24px;\n    }\n\n    .page-title{\n        margin-top: 20px;\n        margin-left: 20px;\n    }\n\n    .page-title-description{\n        margin-top: 20px;\n        margin-left: 20px;\n    }\n\n    .book-image{\n        width: 80%;\n        border-radius: 10px;\n        margin-top: 20px;\n    }\n\n    .facebook-image{\n        width: 60%;\n        border-radius: 10px;\n        margin-top: 20px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
